import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO } from "@/data/content";

export const Seo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = SEO[pathname] || SEO["/"];
    document.title = meta.title;
    let tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", meta.desc);
  }, [pathname]);
  return null;
};
